// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "jy-admin/css/" + chunkId + "." + {"52":"0b8f078e","284":"90ddd612","297":"e3ec6485","488":"ef70df4e","640":"f17af2d5","821":"a4ecd06a","852":"d68166ba","853":"0d587d92"}[chunkId] + ".css";
};